import type { IValidatedResponse } from '../../../httpClient';
import { deleteRequest } from '../../../httpClient';
import type { ICancelSubscriptionResponse } from './cancel-subscription-response';
import { cancelSubscriptionResponseSchema } from './cancel-subscription-response';

export async function cancelAdminSubscriptionApi(
  subscriptionId: string,
): Promise<IValidatedResponse<ICancelSubscriptionResponse>> {
  return deleteRequest<ICancelSubscriptionResponse>({
    path: `/sys/billing/subscriptions/${subscriptionId}`,
    schema: cancelSubscriptionResponseSchema,
  });
}
